import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import { GeoRootHub } from "@/pages/GeoHub";

// §584 — livello radice della gerarchia /medici/{specialita}/{citta}, prima 404
// nonostante fosse già il canonical di fallback delle pagine città.
export const Route = createFileRoute("/medici/")({
  head: () =>
    buildRouteHead({
      pathname: "/medici",
      title: "Refertius città per città: pagine locali per medici | Refertius",
      description:
        "Le pagine locali di Refertius per specialità e città, con il contesto sanitario territoriale e il funzionamento della refertazione assistita.",
    }),
  component: GeoRootHub,
});
